import { FC } from 'react';
import { Pie } from 'react-chartjs-2';
import { mockData } from './constant';
import style from './style';

interface IProps {
  data: any;
  newVersion?: boolean;
}

const Diagram: FC<IProps> = ({ data, newVersion = false }) => {
  const classes = style();

  const processedData = {
    datasets: [
      {
        labels: data.map((i: any) => i.label),
        data: data.map((i: any) => i.value),
        backgroundColor: data.map((i: any) => i.color),
        borderWidth: 0,
        datalabels: {
          labels: {
            name: {
              align: 'end' as const,
              anchor: 'end' as const,
              color: 'white',
              font: {
                size: 50,
                family: 'Poppins',
              },
              display: false,
              clamp: false,
              clip: false,
            },
          },
        },
      },
    ],
    // labels: data.map((i: any) => i.label),
  };
  return (
    <div style={newVersion ? { width: 206, height: 206 } : {}}>
      <Pie
        className={classes.pie}
        width={newVersion ? 206 : undefined}
        height={newVersion ? 206 : undefined}
        data={processedData}
        options={{
          responsive: !newVersion,
          plugins: {
            tooltip: {
              enabled: false,
            },
            datalabels: {
              display: true,
              color: mockData.map((i: any, index: number) => (index < 2 ? 'black' : 'white')),
              clip: true,
              labels: {
                title: {
                  font: {
                    weight: 'bold',
                    size: 11.5,
                  },
                  align: 'center',
                  padding: 0,
                },
              },
              formatter(value: any) {
                return `${value}%`;
              },
            },
          },
          layout: {
            padding: newVersion
              ? 0
              : {
                  top: 10,
                  bottom: 10,
                },
          },
          maintainAspectRatio: false,
        }}
      />
    </div>
  );
};

export default Diagram;
